import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { API_BASE_URL } from '../../../common/tokens/api-base-url.token';
import { NotificationPage } from '../../application/entities/notification.entity';
import { NotificationProviderPort } from '../../application/ports/notification-provider.port';
import {
  NotificationListResponseDto,
  UnreadCountResponseDto,
} from '../dto/notification-response.dto';
import { toNotificationPage } from '../mappers/notification.mapper';

@Injectable({ providedIn: 'root' })
export class NotificationProviderService implements NotificationProviderPort {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(API_BASE_URL);

  list(init: number, limit: number): Observable<NotificationPage> {
    const params = { init, limit, total: true };
    return this.http
      .get<NotificationListResponseDto>(`${this.baseUrl}notifications`, { params })
      .pipe(map(toNotificationPage));
  }

  unreadCount(): Observable<number> {
    return this.http
      .get<UnreadCountResponseDto>(`${this.baseUrl}notifications/unread-count`)
      .pipe(map((res) => res.data.unread));
  }

  markAsRead(uuid: string): Observable<void> {
    return this.http.patch<void>(`${this.baseUrl}notifications/${uuid}/read`, {});
  }

  markAllAsRead(): Observable<void> {
    return this.http.patch<void>(`${this.baseUrl}notifications/read-all`, {});
  }

  clear(uuid: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}notifications/${uuid}`);
  }

  clearAll(): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}notifications`);
  }
}
